export default __webpack_public_path__ + "static/media/GOOGLE_MAPS.bcf6c0f9.png";